import React from "react";

class Footer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="footer-dark">
        <footer>
          <div className="container">
            <div className="row">
              <div className="col-md-3 item text">
                <h3>Pixelinium.com</h3>
                <p>
                  Pixelinium is an indie mobile games developer from Auckland,
                  New Zealand.
                </p>
              </div>
              <div className="col item social">
                <a href="https://twitter.com/PixeliniumGames">
                  <i className="fa fa-twitter"></i>
                </a>
                <a href="https://www.youtube.com/channel/UC4DNpzUTuhQ1GTUxHQlcg5w">
                  <i className="fa fa-youtube"></i>
                </a>
                <a href="https://www.instagram.com/pixeliniumgames/">
                  <i className="fa fa-instagram"></i>
                </a>
              </div>
            </div>
            <p className="copyright">© 2020 Pixelinium.com Ltd</p>
          </div>
        </footer>
      </div>
    );
  }
}

export default Footer;
